import { createSlice } from "@reduxjs/toolkit";

const initialrelatedPatientState = {
    caseSearch: null,
}

const relatedPatientSlice = createSlice({
    name: 'relatedPatient',
    initialState: initialrelatedPatientState,
    reducers: {
        setCaseSearch(state, data) {
            state.caseSearch = data.payload
        },        
    }
})

export const relatedPatientActions = relatedPatientSlice.actions

export default relatedPatientSlice.reducer